
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Link, Router } from '/routes'
import classNames from 'classnames';

const styles = theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    borderRadius: '0',
    '&::before':{
      content: '""',
      width: '100%',
      height: 48,
      backgroundColor: '#000',
      opacity: 0.2,
      position: 'absolute'
    }
  },
  tabsIndicator: {
    backgroundColor: '#fff',
  },
  tabRoot: {
    color: '#fff',
    minWidth: 72,
    // '&$tabSelected': {
    //   color: '#fff',
    // },
    '&:focus': {
      color: '#fff',
    },
  },
  customLabelContainer: {
    padding: 0
  }
 
});

class SubCategoryTabs extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      value : props.subCatIndex
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event, value) => {
    this.setState( { value } );
  };

  render() {
    const { classes, category, categoryUrl, subCatIndex, videoCatPath } = this.props;
    const videoSubCatPath = videoCatPath && ((videoCatPath == "tv" && "categoryTv") || "categoryVideos");
    // console.log("videoCatPath:"+videoCatPath);
    // console.log("videoSubCatPath:"+videoSubCatPath);

    const value = subCatIndex;
    const allSubCategories = category && category.sub_categories;
    const ascendSortSubCategories = allSubCategories && allSubCategories.sort(function(a, b){return a.order - b.order});  
    const items = JSON.parse(JSON.stringify(ascendSortSubCategories));
    items.splice(0, 0, {"name": category && category.name,
    "slug": category && category.slug,
    "color": category && category.color});
    return (
      <Paper className={classNames(classes.root, 'shadowWrapper')} style={{background: category.color, height: 48}}>
        <Tabs
          value={value}
          onChange={this.handleChange}
          classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
          variant="scrollable" 
          scrollButtons="off"
        >
          {items && items.map((subCategoryItem, index) =>
            (
            // <Link key={index} prefetch 
            //   route={ index == 0 ? "category" : "subCategory" } 
            //   params={index == 0 ? { category: category.slug } : { category: category.slug, subCategory: subCategoryItem.slug }}>
            //   <a className="anchor-link">
                <Tab
                  classes={{ root: classes.tabRoot, selected: classes.tabSelected, labelContainer: classes.customLabelContainer }}
                  key={index}
                  label={<Link key={index}  
                  // route={ index == 0 ? "category" : "subCategory" }                   
                  route={ index == 0 ? (videoCatPath || "category") : (videoSubCatPath || "subCategory") } 
                  params={index == 0 ? (videoCatPath ? {} : { category: category.slug }) : (videoCatPath ? {id: subCategoryItem.slug} : { category: category.slug, subCategory: subCategoryItem.slug })}>
                  <a className="anchor-link sub-category-link sub_categories_gtm">{index == 0 ? "All" : subCategoryItem.name}</a></Link>}
                  // onClick={()=> {
                  //     // index == 0 ?
                  //     // Router.pushRoute('category', {category: category.slug}) :
                  //     // Router.pushRoute(
                  //     //   'subCategory', 
                  //     //   { category: category.slug,
                  //     //     subCategory: subCategoryItem.slug 
                  //     //   });
                  //     // window.scrollTo(0, 0)
                  //   }}
                />
           
            )
            )}
        </Tabs>
      
      </Paper>
    );
  }
}

SubCategoryTabs.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SubCategoryTabs);